module.exports = __webpack_public_path__ + "img/zhifubao.ac7ee65c.png";